// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__gsP08","col":"CardReaderDesc_col__1yvrk","label":"CardReaderDesc_label__1aOhq"};